<div class="cc-side-navigator-outer-toolbar side-navigator-outer-toolbar">
    <app-header
        #appHeader
        class="layout-header"
        [menuToggleEnabled]="enableSideMenu"
        [menuUserEnabled]="enableSideMenu"
        (menuToggle)="processMenuToggle()"
    ></app-header>

    <dx-drawer
        position="before"
        [closeOnOutsideClick]="shaderEnabled"
        [openedStateMode]="menuMode"
        [revealMode]="menuRevealMode"
        [minSize]="minMenuSize"
        [shading]="shaderEnabled"
        [(opened)]="menuOpened"
        class="layout-body side-nav-drawer"
    >
        <ng-container *ngIf="enableSideMenu">
            <app-side-navigation-menu
                #sideNavigationTree
                *dxTemplate="let dataMenu of 'panel'"
                class="dx-swatch-additional"
                [topItems]="topMenuItems"
                [bottomItems]="bottomMenuItems"
                [compactMode]="!menuOpened"
                [selectedPath]="selectedRoute"
                [itemToSelect]="itemToSelect"
                (expandSideNavigator)="onOpenMenuClick()"
                (selectedItemChanged)="onNavigationItemClick($event)"
            ></app-side-navigation-menu>
        </ng-container>

        <ng-container>
            <div class="content-holder">
                <div
                    *ngIf="isLarge && !menuOpened && autoShowTopMenu && showTopNavigationMenu"
                    class="top-menu-content cc-top-navigator-menu dx-theme-border-color"
                >
                    <app-top-navigation-menu
                        [showQuickSearch]="true"
                        [showFooterIcons]="true"
                        [topMenuItems]="topMenuItems"
                        [bottomMenuItems]="bottomMenuItems"
                        [selectedPath]="selectedRoute"
                        (onNavigationChanged)="onNavigationItemClick($event)"
                    ></app-top-navigation-menu>
                </div>
                <div class="content">
                    <ng-content></ng-content>
                    <div *ngIf="isXtraSmall" class="content-spacer">&nbsp;</div>
                </div>
            </div>
        </ng-container>
    </dx-drawer>
</div>
